import React, { useState, useEffect, useContext } from "react";
import RegularPage from "../components/UI/RegularPage/RegularPage";
import RequestService from "../api/RequestService";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import EventsFlow from "./EventsFlow";
import { Button, Chip, Icon, Textarea, TextInput } from "react-materialize";
import M from "materialize-css";
import { AuthContext } from "../context";
import useConfirm from "../context/ConfirmDialog";
import { parseForm, showNotification } from "../utils/service";

const EditCollection = () => {
  const [collectionError, setCollectionError] = useState(null);
  const [collectionData, setCollectionData] = useState(null);
  const [currentFilterValue, setCurrentFilterValue] = useState(null);
  const [collectionName, setCollectionName] = useState("");
  const [collectionDescription, setCollectionDescription] = useState("");
  const [collectionDomain, setCollectionDomain] = useState("");
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isFullScreenLoading, setFullScreenLoading } = useContext(AuthContext);
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [collectionButtonText, setCollectionButtonText] =
    useState("Перейти к подборке");

  useEffect(() => {
    getCollection();
  }, []);

  const getCollection = async () => {
    setFullScreenLoading(true);
    const response = (await RequestService.getCollection(params.id)).data;
    setFullScreenLoading(false);
    // console.log(response);
    if (!response.result.is_owner) {
      setCollectionError("Подборка недоступна для редактирования");
    }
    if (!response.response_code) {
      setCollectionError(response.message);
      return;
    }

    setCollectionName(response.result.name ? response.result.name : "");
    setCollectionDescription(
      response.result.description ? response.result.description : ""
    );
    setCollectionDomain(response.result.domain ? response.result.domain : "");

    setCollectionData(response.result);
    navigate("?" + response.result.filter);
  };

  // useEffect(() => {
  //   let getParams = searchParams.toString();

  //   if (collectionData) {
  //     // console.log(getParams, collectionName, collectionDescription);
  //     updateCollection({
  //       collection_id: params.id,
  //       filter: getParams,
  //       name: collectionName,
  //       description: collectionDescription,
  //       domain: collectionDomain,
  //     });
  //   }
  // }, [
  //   searchParams,
  //   collectionName,
  //   collectionDescription,
  //   collectionData,
  //   collectionDomain,
  // ]);

  // const updateCollection = async (data) => {
  //   setCollectionButtonText("Сохраняем изменения...");
  //   const response = (await RequestService.updateCollection(data)).data;
  //   // console.log(response);
  //   setTimeout(() => {
  //     setCollectionButtonText("Перейти к подборке");
  //   }, 2000);

  //   if (!response.response_code) {
  //     await confirm({
  //       description: response.message,
  //       isAlert: true,
  //     });
  //     // alert(response.message);
  //     return;
  //   }
  // };

  const saveCollectionData = async (e) => {
    e.preventDefault();
    setFullScreenLoading(true);
    let htmlForm = e.currentTarget;
    // console.log(htmlForm);

    let sendFormData = parseForm(htmlForm);
    sendFormData.append("collection-filter", searchParams.toString());
    const response = (
      await RequestService.sendForm(sendFormData, "/collections/update")
    ).data;
    // console.log(response);
    setFullScreenLoading(false);

    if (!response.response_code) {
      await confirm({
        description: response.message,
        isAlert: true,
      });
      // alert(response.message);
      return;
    }

    getCollection();
  };

  const connectDomain = async () => {
    const choice = await confirm({
      description:
        "Будет создана заявка на прикрепление домена к подборке. Домен будет прикреплен в течение 15 минут. Проверить результат вы сможете, если перейдете по вашему домену в браузере.",
    });
    if (choice) {
      setFullScreenLoading(true);
      const response = (
        await RequestService.connectDomainToCollection(params.id)
      ).data;
      setFullScreenLoading(false);
      // console.log(response);
      if (!response.response_code) {
        await confirm({
          description: response.message,
          isAlert: true,
        });
        // alert(response.message);
        return;
      }

      await confirm({
        description:
          "Заявка создана. Дополнительных действий не требуется. Через 15 минут откройте свой домен, чтобы проверить результат.",
        isAlert: true,
      });
    }
  };

  const disconnectDomain = async () => {
    const choice = await confirm({
      description:
        "Домен будет откреплен от подборки. Она больше не будет открываться по адресу «" +
        collectionDomain +
        "»",
    });
    if (choice) {
      setFullScreenLoading(true);
      const response = (
        await RequestService.disconnectDomainFromCollection(params.id)
      ).data;
      setFullScreenLoading(false);
      // console.log(response);
      if (!response.response_code) {
        await confirm({
          description: response.message,
          isAlert: true,
        });
        // alert(response.message);
        return;
      }

      await confirm({
        description:
          "Домен будет откреплен в ближайшее время. Дополнительных действий не требуется.",
        isAlert: true,
      });
    }
  };

  return (
    <EventsFlow
      header={"Редактирование подборки"}
      // additionalFunc1={setCurrentFilterValue}
      customError={collectionError}
      callbackApplyFilter={() => {
        showNotification(
          "Не забудьте сохранить изменения",
          "Информация",
          null,
          4000
        );
      }}
      additionalContent={
        <div className="row">
          <div className="col s12">
            <div className="card">
              <div className="card-content">
                <div className="row nm">
                  <div className="col s12 secondary-color mb25">
                    Подборки — это совокупность событий по заранее установленным
                    параметрам, например, события только с тегом «Инвестиции» от
                    конкретного организатора. Готовая подборка отображается как
                    отдельная страница, поэтому ей можно дать название и
                    описание. Подборки доступны неограниченному кругу лиц по
                    прямой ссылке.
                  </div>

                  <form id="edit-collection" onSubmit={saveCollectionData}>
                    <TextInput
                      id="collection-name"
                      name="collection-name"
                      icon="local_activity"
                      s={12}
                      label="Название коллекции"
                      placeholder="События про животных"
                      value={collectionName}
                      onChange={(e) => {
                        setCollectionName(e.target.value);
                      }}
                    />

                    <Textarea
                      id="collection-description"
                      name="collection-description"
                      label={"Описание"}
                      icon={<Icon>description</Icon>}
                      placeholder={"Необязательно, но можете добавить описание"}
                      s={12}
                      style={{ marginBottom: "0px" }}
                      value={collectionDescription}
                      onChange={(e) => {
                        setCollectionDescription(e.target.value);
                      }}
                    />

                    <div className="col s12 mb15 secondary-color">
                      Чтобы привязать собственный домен к подборке событий
                      (например, создать таким образом афишу своих мероприятий),
                      сначала создайте в своей панели управления DNS-записями
                      желаемую подзону (например, afisha.yourdomain.com), затем
                      внутри нее укажите CNAME-запись со значением (точка на
                      конце обязательна):{" "}
                      <pre style={{ backgroundColor: "var(--divider-color)" }}>
                        <code> cname.nott.one.</code>
                      </pre>{" "}
                      После этого укажите в поле ниже созданный поддомен,
                      который станет ссылкой на вашу подборку (например,
                      afisha.yourdomain.com). Указывать нужно только хост. На
                      то, чтобы функция вступила в силу потребуется от 15 минут
                      до 24 часов — все зависит от обновления DNS-серверов.
                    </div>

                    <TextInput
                      id="collection-domain"
                      name="collection-domain"
                      icon="language"
                      s={12}
                      label="Домен"
                      placeholder="Например, afisha.yourdomain.com"
                      value={collectionDomain}
                      onChange={(e) => {
                        setCollectionDomain(e.target.value);
                      }}
                    />

                    {collectionData && collectionData.domain ? (
                      <div
                        className={
                          collectionData && collectionData.has_cname
                            ? "col s12 success-color"
                            : "col s12 alert-color"
                        }
                      >
                        {collectionData && collectionData.has_cname ? (
                          <div className="row nm">
                            <div className="col s12">
                              Домен направлен на наш сервер. Мы готовы к
                              подключению домена к подборке.
                            </div>
                            <div className="col s12 mt15">
                              <Button
                                className="iq-btn pastel-btn"
                                type="button"
                                onClick={connectDomain}
                              >
                                Подключить домен
                              </Button>
                            </div>
                            <div className="col s12 mt15">
                              <Button
                                className="iq-btn iq-btn-delete"
                                type="button"
                                onClick={disconnectDomain}
                              >
                                Отключить домен
                              </Button>
                            </div>
                          </div>
                        ) : (
                          "Пока мы не увидели, что домен ведет на наш сервер. Изменения в DNS могут занять до 24 часов."
                        )}
                      </div>
                    ) : null}

                    <input
                      type="hidden"
                      name="collection-id"
                      id="collection-id"
                      value={params.id}
                    />

                    <div className="col s12">
                      <Button
                        icon={<Icon left>save</Icon>}
                        className="iq-btn"
                        style={{ marginRight: "10px", marginTop: "25px" }}
                        type="submit"
                      >
                        Сохранить изменения
                      </Button>

                      <Link to={"/collections/" + params.id}>
                        <Button
                          icon={<Icon left>open_in_new</Icon>}
                          className="iq-btn"
                          style={{ marginTop: "25px" }}
                          type="button"
                        >
                          Перейти к подборке
                        </Button>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default EditCollection;
